"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Manager = void 0;
var Manager_1 = require("./Manager");
Object.defineProperty(exports, "Manager", { enumerable: true, get: function () { return __importDefault(Manager_1).default; } });
